import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import vuetify from './plugins/vuetify';
import VueTextAreaAutoSize from 'vue-textarea-autosize';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VuetifyConfirm from 'vuetify-confirm'
import moment from 'moment'
//import TimeAgo from 'vue2-timeago'
//import 'vue2-timeago/dist/vue2-timeago.css'

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.use(VuetifyConfirm, { vuetify })

const fb = require('./firebaseConfig.js')

Vue.use(VueTextAreaAutoSize);
//Vue.use(TimeAgo)

Vue.config.productionTip = false


const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    //vm = null;
    //trace = null;
  }
}

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})


router.beforeEach((to, from, next) => {
  //console.log("From",from)

  if ( from.name == "Documents" && to.name == "Login" ) {
    //return router.push('/documents')
  }else{
    return next()
  }

  
})


//const auth = firebase.auth() 

//handle page reloads
let app
fb.auth.onAuthStateChanged(()=>{
  if (!app){
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)    
    });
    app.$mount('#app');
  }
})

/*
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
*/